import React from 'react';
import CompanyInfo from './CompanyInfo';
import QuickLinks from './QuickLinks';
import Activities from './Activities';
import Newsletter from './Newsletter';
import BottomFooter from './BottomFooter';
import SocialLinks from './SocialLinks';

const Footer = () => {
  return (
    <footer id="footer" className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info - visible on all screens */}
          <div className="space-y-6">
            <CompanyInfo />
            {/* Social Links - shown below Company Info on mobile, hidden on larger screens */}
            <div className="md:hidden">
              <SocialLinks />
            </div>
          </div>
          
          {/* Quick Links with collapsible functionality */}
          <QuickLinks />
          
          {/* Activities with collapsible functionality */}
          <Activities />
          
          {/* Newsletter and Social Links (on desktop) */}
          <div className="space-y-6">
            <Newsletter />
            {/* Social Links - hidden on mobile, shown on desktop */}
            <div className="hidden md:block">
              <SocialLinks />
            </div>
          </div>
        </div>
        <BottomFooter />
      </div>
    </footer>
  );
};

export default Footer;